/**
 * @file wrapperController
 * wrapper要素の固定/解除を行うユーティリティ。
 *
 * モーダルやドロワー表示時に背景スクロールを止めるため、
 * wrapper要素を `position: fixed` にし、スクロール位置を復元できるよう保持する。
 *
 * 注意:
 * - DOM上に `#wrapper` が存在する前提
 * - `inert` を使用するため、対応ブラウザを想定
 *
 * @typedef {Object} WrapperController
 * @property {() => void} fixed wrapperを固定し、背景スクロールを止める
 * @property {() => void} cancelFixed wrapper固定を解除し、元のスクロール位置へ戻す
 */

const wrapperEl = document.getElementById('wrapper');
const wrapperStyle = wrapperEl?.style ?? null;
let scrollTop = 0;

/** @type {WrapperController} */
export const wrapperController = {
    /**
     * wrapperを固定し、背景スクロールを停止する。
     *
     * @returns {void}
     */
    fixed() {
        if (!wrapperStyle || !wrapperEl) {
            console.warn('[wrapperController] #wrapper が見つかりません');
            return;
        }

        scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
        wrapperEl.inert = true;
        wrapperStyle.position = 'fixed';
        wrapperStyle.top = `-${scrollTop}px`;
        window.scrollTo({ top: 0, left: 0 });
    },

    /**
     * wrapperの固定状態を解除し、元のスクロール位置へ戻す。
     *
     * @returns {void}
     */
    cancelFixed() {
        if (!wrapperStyle || !wrapperEl) {
            console.warn('[wrapperController] #wrapper が見つかりません');
            return;
        }

        wrapperEl.inert = false;
        wrapperStyle.position = '';
        wrapperStyle.top = '';
        window.scrollTo({ top: scrollTop, left: 0 });
    }
};
